<template>
    <div class="contArea tpd"
         style="text-align: center; width: 100%;"
    >
      <div style="padding: 30px 30px;"><img :src="`${$store.state.dir}images/ico_complete.png`"/></div>

      <p style="line-height: 1.5; font-size: 1.2rem; padding-bottom: 120px">
        {{solicitation['name']}} 고객님의
        <span style="color:royalblue">BMW ServiceCare+ / {{solicitation['options']['pkg']['title']}}</span>
        멤버십 가입신청이 완료 되었습니다.
      </p>

      <p style="padding-bottom: 80px">
        가입승인은 신청 후 영업일 기준 4일 이내 승인완료 됩니다.<br>
        가입승인 후 익일부터 서비스를 이용하실 수 있습니다.
      </p>

    </div>
</template>
<script>
export default{
  props: {solicitation: Object},
}
</script>
